<h2 mat-dialog-title>Betriebsart editieren</h2>
<mat-dialog-content>
    <mat-form-field style="width: 100%">
        <input
            type="number"
            matInput
            placeholder="Sortierung"
            [formControl]="sortierungCtrl"
            [attr.data-cy]="'debdebd_input_1_1'"
        />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <input
            type="text"
            matInput
            placeholder="Bezeichnung"
            [formControl]="betriebsartCtrl"
            [attr.data-cy]="'debdebd_input_2_1'"
        />
    </mat-form-field>
    <br />
    <mat-checkbox style="margin-right: 24px" [formControl]="kaelbermastCtrl" [attr.data-cy]="'debdebd_mat-checkbox_1_3'"
        >K&auml;lbermast</mat-checkbox
    ><br />
    <mat-checkbox [formControl]="ohrmarkeCtrl" [attr.data-cy]="'debdebd_mat-checkbox_2_3'">Ohrmarke</mat-checkbox><br />
    <mat-checkbox [formControl]="qsCtrl" [attr.data-cy]="'debdebd_mat-checkbox_3_3'">QS</mat-checkbox><br />
    <mat-checkbox [formControl]="hitCtrl" [attr.data-cy]="'debdebd_mat-checkbox_4_3'">HIT</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" [attr.data-cy]="'debdebd_button_1_0'">Abbrechen</button>
    <button
        mat-raised-button
        color="primary"
        (click)="save()"
        *kienePermission="[3103]"
        [attr.data-cy]="'debdebd_button_2_0'"
        >Speichern</button
    >
</mat-dialog-actions>
